import { ApiEmployee, ApiEmployeeShort } from "@/types/employees/employee.types.ts";
import { Rule, RuleGroup, RuleGroupShort } from "@/types/rule.types.ts";
import { ApiPagedData } from "@skailer-com/uikit/core";

export interface ApiRecognition {
  id: number;
  category_id: number;
  title: string;
  description: string;
  sort: number;
  is_system: boolean;
  system_icon_code: string | null;
  badge_file_uuid: string | null;
  badge_url: string | null;
  created_by: ApiEmployee | null;
  granted_count: number;
  is_archived: boolean;
  can_gift: boolean;
}

export interface ApiRecognitionCategory {
  id: number;
  title: string;
  description: string;
  sort: number;
  is_system: boolean;
  recognitions_count: number;
  is_archived: boolean;
  gift_apply_to_groups?: RuleGroup[] | null;
  gift_apply_to?: Rule[] | null;
}

export function getRecognitionGiftRuleGroups(category: ApiRecognitionCategory): RuleGroup[] {
  if (category.gift_apply_to_groups != null) return category.gift_apply_to_groups;
  const rules = category.gift_apply_to ?? [];
  return rules.length > 0 ? [{ rules }] : [];
}

export interface ApiRecognitionCategoryPayload {
  title: string;
  description: string;
  gift_apply_to_groups: RuleGroupShort[];
}

export interface ApiRecognitionPayload {
  category_id: number;
  title: string;
  description: string;
  system_icon_code: string | null;
  badge_file_uuid: string | null;
}

export interface ApiRecognitionMassGiftPayload {
  recognition_id: number;
  recipient_rule_groups: RuleGroupShort[];
  comment?: string | null;
  datetime_awarded_at?: Date | null;
}

export interface ApiRecognitionMassGiftPreviewFilter {
  recipient_rule_groups: RuleGroupShort[];
}

export interface ApiRecognitionMassGiftPreview {
  recipients_count: number;
  recipients: ApiEmployeeShort[];
}

export interface ApiEmployeeRecognitionTemplate {
  id: number;
  title: string;
  description?: string | null;
  category: ApiRecognitionCategory;
  system_icon_code: string | null;
  badge_url: string | null;
  is_archived: boolean;
}

export interface ApiEmployeeRecognitionACL {
  can_edit: boolean;
  can_revoke: boolean;
}

export interface ApiEmployeeRecognition {
  id: number;
  employee: ApiEmployeeShort;
  recognition: ApiEmployeeRecognitionTemplate;
  recognition_title: string;
  awarded_by: ApiEmployee;
  datetime_awarded_at: Date;
  comment: string | null;
  datetime_revoked_at: Date | null;
  revoked_by: ApiEmployeeShort | null;
  acl: ApiEmployeeRecognitionACL;
}

export interface ApiEmployeeRecognitionGift {
  recognition_id: number;
  comment?: string | null;
  datetime_awarded_at?: Date | null;
}

export interface ApiEmployeeRecognitionUpdate {
  comment?: string | null;
  datetime_awarded_at?: Date | null;
}

export interface ApiEmployeeRecognitionFilter {
  page_number: number;
}

export interface ApiRecognitionHistoryFilter {
  page_number: number;
  text?: string | null;
  employee_ids?: number[] | null;
  department_ids?: number[] | null;
  recognition_ids?: number[] | null;
  awarded_by_ids?: number[] | null;
  date_from?: Date | null;
  date_to?: Date | null;
}

export interface ApiEmployeeRecognitionsSearchData extends ApiPagedData<ApiEmployeeRecognition> {
  can_gift: boolean;
}
